import { FunctionComponent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useConfig } from '@browsing/config';
import { useConsentManager } from '@browsing/tracking';
import { addUsabillaToWindow, UsabillaInitOptions } from '@browsing/usabilla';

import { toNumberOrZero } from '@client/helpers';
import { useDealsMyLoungeSurvey } from '@client/hooks';
import { getCustomer } from '@client/redux/modules/customer';

export const Usabilla: FunctionComponent = () => {
    const config = useConfig();
    const [hasConsent] = useConsentManager('usabilla_lounge');
    const customer = useSelector(getCustomer);
    const showDealsMyLoungeSurvey = useDealsMyLoungeSurvey();

    useEffect(() => {
        if (config?.isEnabled('usabilla') && hasConsent) {
            const visits = toNumberOrZero(
                window.localStorage.getItem('zl_mylounge_page_view_count'),
            );
            addUsabillaToWindow({
                campaigns: config.usabilla as UsabillaInitOptions['campaigns'],
                customVariables: {
                    showDealsMyLoungeSurvey,
                },
                auxiliaryData: {
                    customer: customer?.hashedCustomerNumber,
                    myLoungePageViewCount: visits,
                },
            });
        }
    }, [config, hasConsent, customer?.hashedCustomerNumber, showDealsMyLoungeSurvey]);

    return null;
};

export default Usabilla;
